'use strict';

class AccountConfirm {
  constructor($location, commonService, originatorService) {
    this.$location = $location;
    this.commonService = commonService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.type = this.$location.search().error;

    this.originator = {
      name: null,
      email: null,
      address: {
        country: 'NORGE'
      }
    };

    this.load();
  }

  load() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = {
          name: resp.data.name,
          address: {
            address1: resp.data.contact.address.address1,
            address2: resp.data.contact.address.address2,
            zip: resp.data.contact.address.zip,
            city: resp.data.contact.address.city,
            country: resp.data.contact.address.country
          }
        };
      });

    this.originatorService.settings()
      .then((resp) => {
        this.originator.email = resp.data.sendRegningContactEmail;
      });

    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });
  }

  lookup(zip) {
    if (zip && this.originator.contact.address.country === 'NORGE') {
      if (zip.length === 4) {
        this.commonService.getCityByPostCode(zip)
          .then((resp) => {
            this.originator.contact.address.city = resp.data.city ? resp.data.city : 'OLSO';
          });
      }
    }
  }

  save() {
    this.originatorService.confirm(this.originator)
      .then(() => this.$location.path('/'));
  }
}

AccountConfirm.$inject = ['$location', 'commonService', 'originatorService'];

const accountConfirm = {
  controller: AccountConfirm,
  template: `
    <h2>Vennligst bekreft din kontaktinformasjon</h2>

    <div class="alert-box info" ng-if="$ctrl.type === 'epost'">
      Din konto har v&aelig;rt stengt fordi vi ikke fikk levert e-post til den oppgitte adressen. Kontoen vil &aring;pnes automatisk n&aring;r du bekrefter e-postadressen.
    </div>

    <div class="alert-box info" ng-if="$ctrl.type === 'adresse'">
      Din konto har v&aelig;rt stengt fordi vi fikk en purring vi har sendt til din postadresse i retur. Kontoen vil &aring;pnes automatisk n&aring;r du bekrefter adressen, dersom utest&aring;ende har blitt betalt.
    </div>

    <form ng-submit="$ctrl.save()">

      <div class="row">
        <div class="large-6 columns">
          <fieldset>

            <div>
              <label for="name">Navn</label>
              <input type="text" id="name" name="name" autocomplete="name" ng-model="$ctrl.originator.name">
            </div>

            <div>
              <label for="email">
                E-postadresse
                <span data-balloon-length="large" data-balloon="Dette er e-postadressen SendRegning bruker for &aring; kontakte deg. E-postadressene p&aring; dine utg&aring;ende regninger og til innlogging vil ikke oppdateres hvis du endrer e-postadresse her."><i class="fa fa-question-circle"></i></span>
              </label>
              <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.originator.email" maxlength="64" placeholder="ola@nordmann.no">
            </div>

          </fieldset>
        </div>

        <div class="large-6 columns">
          <fieldset>

            <div>
              <label for="address1">Adresse</label>
              <input type="text" id="address1" name="address1" ng-model="$ctrl.originator.address.address1" maxlength="42">
              <input type="text" id="address2" name="address2" ng-model="$ctrl.originator.address.address2" maxlength="42">
            </div>

            <div class="row">
              <div class="large-5 columns">
                <label for="zip">Postnummer</label>
                <input type="text" id="zip" name="zip" ng-model="$ctrl.originator.address.zip" ng-change="$ctrl.lookup($ctrl.originator.address.zip)" ng-model-options="{ debounce: 300 }" required>
              </div>
              <div class="large-7 columns">
                <label for="city">Sted</label>
                <input type="text" id="city" name="city" ng-model="$ctrl.originator.address.city" maxlength="32" required>
              </div>
            </div>

            <div>
              <label for="country">Land</label>
              <select id="country" ng-model="$ctrl.originator.address.country" ng-options="country for country in $ctrl.countries"></select>
            </div>

          </fieldset>

        </div>
      </div>

      <button type="submit" class="button">Lagre</button>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('accountConfirm', accountConfirm)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/bekreft', {
        title: 'Bekreft konto',
        template: '<account-confirm />',
        noSidebar: true,
        noNav: true,
        secure: true
      });
  });
